import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faEye, faPenToSquare, faPlus, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/layout/Pagination'
import { toast } from 'react-toastify';

function BlogsManagement() {
  const [blogs, setBlogs] = useState([])
  const token = localStorage.getItem('authToken');
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortBy, setSortBy] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [searchedBlog, setSearchedBlog] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null)
  const [errorMessage, setErrorMesage] = useState('')
  const [errors, setErrors] = useState({});
  const [blogToDelete, setBlogToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  const location = useLocation()
  const navigate = useNavigate();

  const openAddModal = () => {
    setSelectedBlog({
      title: "",
      content: "",
      imageUrl: "",
      subImageUrl: "",
      subtitle: "",
      subContent: "",
      subImageUrl1: "",
      subtitle1: "",
      subContent1: "",
      subImageUrl2: "",
      subtitle2: "",
      subContent2: "",
    });
    setModalOpen(true);
  };

  const validateInputs = () => {
    const newErrors = {};

    if (!selectedBlog.title) newErrors.title = "Насловот е задолжителен!";
    if (!selectedBlog.content) newErrors.content = "Текстот е задолжителен!";
    if (!selectedBlog.imageUrl) newErrors.imageUrl = "Сликата е задолжителна!";

    return Object.keys(newErrors).length > 0 ? newErrors : null;  // Врати го новиот објект со грешки ако има или null ако нема грешки
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sortByUrl = queryParams.get('sortBy') ?? '';
    const pageSizeUrl = queryParams.get('pageSize') ?? pageSize;
    const currentPageUrl = queryParams.get('currentPage') ?? 1;
    const totalPagesUrl = queryParams.get('totalPages') ?? 0;
    setCurrentPage(currentPageUrl)
    setTotalPages(totalPagesUrl)
    setSortBy(sortByUrl)
    setPageSize(pageSizeUrl)
    fetchBlogs(searchedBlog, sortByUrl, pageSizeUrl, currentPage)
  }, [location.search, currentPage])

  const fetchBlogs = async (searchedBlog, sortBy, pageSize, currentPage) => {
    try {
      setLoading(true)

      const response = await fetch(`${API_URL}/blog/getBlogs?title=${searchedBlog}&sortBy=${sortBy}&pageNumber=${currentPage}&pageSize=${pageSize}`, {
        method: 'GET',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',  // Specify the content type
        }
      })

      if (response.status === 401) {
        navigate('/');
      }

      const result = await response.json()
      if (result?.data?.blogs) {
        const newQueryParams = new URLSearchParams(location.search);
        setBlogs(result.data.blogs);
        setTotalPages(result.data.totalPages);
        setTotalItems(result.data.totalItems);
        setLoading(false)

        if (result.data.totalPages) {
          newQueryParams.set("totalPages", result.data.totalPages);
        }
        //navigate({ search: newQueryParams.toString() });
      } else {
        setBlogs([])
        setLoading(false)
      }
    }
    catch (error) {
    }
  }

  const handlePageChange = (page) => {
    const newQueryParams = new URLSearchParams(location.search);

    if (page) {
      newQueryParams.set('currentPage', page);
    } else {
      newQueryParams.delete('currentPage');
    }
    navigate({ search: newQueryParams.toString() });

    setCurrentPage(page)
  };



  const handleSortByChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setSortBy(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handlePageSizeChange = (e) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set('currentPage', '1');
    const { name, value } = e.target;

    if (value) {
      newQueryParams.set(name, value);
    } else {
      newQueryParams.delete(name); // Избриши ако нема вредност
    }
    setPageSize(e.target.value);

    navigate({ search: newQueryParams.toString() });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchIconClick(); // Повикај ја функцијата ако е притиснат Enter
    }
    if (event.key === 'Escape') {
      clearInput();
    }
  };

  const handleSearchIconClick = () => {
    if (searchedBlog.length > 0 && searchedBlog.length < 2) {
      return;
    }
    fetchBlogs(searchedBlog, sortBy, pageSize, currentPage);
  };

  const clearInput = () => {
    setSearchedBlog('');
    fetchBlogs('', sortBy, pageSize, currentPage);
  };

  const convertDateTime = (created) => {
    if (created != null) {
      const dateObject = new Date(created);
      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const datePart = dateObject.toLocaleDateString('en-GB', options);
      const timePart = dateObject.toLocaleTimeString();
      return `${datePart} ${timePart}`;
    }
  }

  const closeEditModal = () => {
    setModalOpen(false);
    setSelectedBlog(null);
    setErrors({});
  };

  const handleBlog = () => {
    if (selectedBlog.id) {
      handleBlogEdit()
    } else {
      handleBlogAdd()
    }
  };

  const handleBlogEdit = async () => {
    setLoading(true)

    const validationErrors = validateInputs();

    if (validationErrors) {
      setErrors(validationErrors);
      setLoading(false)
      return;
    }

    const response = await fetch(`${API_URL}/blog/${selectedBlog.id}`, {
      method: 'PUT',
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',  // Specify the content type
      },
      body: JSON.stringify(selectedBlog),
    })

    const result = await response.json()

    if (result.statusCode === 204) {
      setBlogs(blogs.map(blog =>
        blog.id === selectedBlog.id ? selectedBlog : blog
      ));

      closeEditModal(false);
      setLoading(false);
      toast.success(`${selectedBlog.title} е успешно ажуриран!`);
    } else {
      setErrorMesage("Блогот не е успешно променет!");
      closeEditModal(false);
      setLoading(false)
    }
  };

  const handleBlogAdd = async () => {
    setLoading(true)
    
    const validationErrors = validateInputs();

    if (validationErrors) {
      setErrors(validationErrors);
      setLoading(false)
      return;
    }
    
    try {
      const response = await fetch(`${API_URL}/blog/addBlog`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${token}`,
          'Content-Type': 'application/json',  // Specify the content type
        },
        body: JSON.stringify(selectedBlog),
      })

      const result = await response.json()

      if (result.statusCode === 201) {
        setBlogs([...blogs, result.data]);
        closeEditModal(false);
        setLoading(false)
        toast.success(`${selectedBlog.title} е успешно додаден!`);
      } else {
        setErrorMesage("Блогот не е успешно додаден!");
        setLoading(false)
      }
    }
    catch {
      setErrorMesage("Блогот не е успешно додаден!");
      setLoading(false)
    }
  };

  const openEditModal = (blog) => {
    setSelectedBlog(blog);
    setModalOpen(true);
  };

  const removeImage = async (e, image) => {
    const { name } = e.target;
    setLoading(true)

    const response = await fetch(`${API_URL}/Image?url=${encodeURIComponent(image)}&imageId=${image.id ? image.id : 0}`, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`,
      }
    })

    const result = await response.json()
    if (result) {

      setSelectedBlog((prevBlog) => ({
        ...prevBlog,
        [name]: "", // Отстранува слика на дадениот индекс
      }));


      setLoading(false);
    }
    else {
      toast.warning('Настана проблем при бришењето на фотографијата');
      setLoading(false)
    }
  };

  const handleImageUpload = async (e, files) => {

    const { name } = e.target;
    setLoading(true)
    try {
      const formData = new FormData();

      // Додај ги сите слики во formData

      files.forEach((file) => {
        formData.append('files', file);
      });


      // Испрати ги сликите на серверот (промени ја URL-то според твојот сервер)
      const response = await fetch(`${API_URL}/Image/upload`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${token}`,
        },
        body: formData,
      });
      if (response.status === 200) {

        const result = await response.json()
        const uploadedImageUrl = result.imageUrls[0]; // Adjust based on your server response
        const imageUrl = uploadedImageUrl;

        setSelectedBlog((prevImage) => ({
          ...prevImage,
          [name]: imageUrl,
        }));
        setLoading(false);
      }
      else {
        toast.error('Се случи проблем при додавањето на фотографијата')
        setLoading(false);
      }

    } catch (error) {
      console.error('Upload error:', error);
      setLoading(false);
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files); // Претвори ги во масив
    handleImageUpload(e, files); // Повикај ја функцијата за upload
  };


  const openDeleteModal = (blog) => {
    setBlogToDelete(blog);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setBlogToDelete(null);
  };

  const confirmDelete = () => {
    deleteBlog(blogToDelete);
  };

  const deleteBlog = async (blog) => {
    setLoading(true);

    const response = await fetch(`${API_URL}/blog/${blog.id}`, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',  // Specify the content type
      }
    })
    const result = await response.json()

    if (result.statusCode === 204) {
      toast.success(`${blog.title} е успешно избришан!`);
      setBlogs(blogs.filter((item) => item.id !== blog.id));
      setLoading(false);
      closeDeleteModal();
    } else {
      toast.warning(`${blog.title} не е успешно избришан!`);
      setLoading(false);
      closeDeleteModal();
    }
  }


  return (
    <div className="p-6">
      <div className='flex flex-col'>
        <div className='ml-auto'>
          <label htmlFor='pageSize'>Прикажи:</label>
          <select
            className="mb-4"
            name='pageSize'
            id='pageSize'
            value={pageSize}
            onChange={handlePageSizeChange}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="50">50</option>
          </select>
        </div>
        <div className='ml-auto'>
          <select
            className="mb-4"
            name='sortBy'
            value={sortBy}
            onChange={handleSortByChange}
          >
            <option value="">Стандардно подредување</option>
            <option value="created_desc">Најнови додадени</option>
            <option value="created_asc">Најстари додадени</option>
          </select>
        </div>
      </div>
      <div className='flex justify-between'>
        <div className="flex items-center border border-gray-300 rounded-lg p-[1px] max-w-[200px] mr-1">
          <input
            type="text"
            className="flex-grow p-1 outline-none w-full"
            placeholder="Пребарувај блогови"
            value={searchedBlog}
            onChange={(e) => setSearchedBlog(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          {searchedBlog && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-5 w-5 text-gray-500 cursor-pointer"
              onClick={clearInput}
            >
              <path
                fillRule="evenodd"
                d="M11.03 4.97a1 1 0 0 0-1.415 0L8 6.585 5.385 4.97a1 1 0 1 0-1.415 1.415L6.585 8l-2.615 2.615a1 1 0 1 0 1.415 1.415L8 9.415l2.615 2.615a1 1 0 0 0 1.415-1.415L9.415 8l2.615-2.615a1 1 0 0 0 0-1.415z"
                clipRule="evenodd"
              />
            </svg>
          )}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            fill="currentColor"
            className="h-5 w-5 text-gray-500 cursor-pointer"
            onClick={handleSearchIconClick}
          >
            <path
              fillRule="evenodd"
              d="M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div>
          <button className='btn btn-primary btn-sm' onClick={openAddModal}>
            <FontAwesomeIcon icon={faPlus} />
            Додади Блог
          </button>

        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="table min-w-[600px] w-full">
          <thead>
            <tr className='text-sm'>
              <th className='w-[30px]'>Id</th>
              <th>Наслов</th>
              <th>Креиран</th>
              <th>Акција</th>
            </tr>
          </thead>
          <tbody>
            {blogs.map(blog => (
              <tr key={blog.id}>
                <td className='font-semibold'>{blog.id}</td>
                <td className=''>{blog.title}</td>
                <td className=''>{convertDateTime(blog.created)}</td>
                <td>
                  <button
                    className="btn btn-sm btn-primary ml-2"
                    onClick={() => openEditModal(blog)}
                  >
                    <FontAwesomeIcon icon={faPenToSquare} />
                  </button>
                  <button
                    className="btn btn-sm btn-error ml-2"
                    onClick={() => openDeleteModal(blog)}
                  >
                    <FontAwesomeIcon icon={faTrashCan} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {blogs.length > 0 && (
          <>
            <div className='text-center'>Тековна страна: {currentPage}</div>
            <div className='text-center'>Вкупно производи: {totalItems}</div>
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            /></>
        )}
      </div>
      {modalOpen && selectedBlog && (
        <div className="modal modal-open">
          <div className="modal-box max-w-[800px]">
            <div className="flex items-center justify-center p-4 flex-wrap">
              <div className='ml-auto'>
                <button onClick={() => closeEditModal(true)} disabled={loading}>
                  <FontAwesomeIcon icon={faCircleXmark} />
                </button>
              </div>
              <div className="mx-auto w-full bg-white mb-auto">
                <div>
                  <h1 className='text-4xl font-bold mb-8 mt-8 text-center'>{selectedBlog.id ? 'Промени податоци за блог' : 'Додај нов блог'}</h1>
                </div>
                {selectedBlog.id && (<p className='text-base'>Id - {selectedBlog.id}</p>)}
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="title" className="mb-1 block text-base font-medium text-[#07074D]">
                        Наслов<span className='text-red-500 tooltip' data-tip="Насловот е задолжителен">*</span>
                      </label>
                      <input type="text" name="title" id="title" value={selectedBlog.title}
                        required
                        onChange={(e) => setSelectedBlog({ ...selectedBlog, title: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                        {errors.title && (
                        <p className="text-red-500 text-sm ">{errors.title}</p>)}
                    </div>
                  </div>
                  <div className="w-full px-3 ">
                    <div className="mb-2">
                      <label htmlFor="content" className="mb-1 block text-base font-medium text-[#07074D]">
                        Текст<span className='text-red-500 tooltip' data-tip="Текстот на блогот е задолжителен">*</span>
                      </label>
                      <textarea type="textarea" name="content" id="content" value={selectedBlog.content}
                        required
                        onChange={(e) => setSelectedBlog({ ...selectedBlog, content: e.target.value })}
                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" ></textarea>
                        {errors.content && (
                        <p className="text-red-500 text-sm ">{errors.content}</p>)}
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="imageUrl" className="mb-1 block text-base font-medium text-[#07074D]">
                        Слика<span className='text-red-500 tooltip' data-tip="Главната слика е задолжителна">*</span>
                      </label>
                      <input type="file" name="imageUrl" id="imageUrl" accept="image/*" disabled={selectedBlog.imageUrl !== ""}
                        onChange={handleImageChange}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-1 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm text-xs" />
                      {errors.imageUrl && (
                        <p className="text-red-500 text-sm ">{errors.imageUrl}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mt-4">
                      <h2 className="text-xl font-bold">Преглед на слика:</h2>
                      <div className="flex gap-4 ">
                        {selectedBlog.imageUrl && <div className="relative">
                          <img src={selectedBlog.imageUrl} alt={`Слика од производот ${selectedBlog.imageUrl}`} className="w-20 h-20 object-cover rounded-md" />
                          <button
                          name='imageUrl'
                            onClick={(e) => removeImage(e, selectedBlog.imageUrl)}
                            className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1"
                          >
                            X
                          </button>
                        </div>}
                      </div>
                    </div>
                  </div>
                </div>
                <h3 className='text-3xl mt-4 mb-4'>Втора секција</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="subtitle" className="mb-1 block text-base font-medium text-[#07074D]">
                        Поднаслов 1
                      </label>
                      <input type="text" name="subtitle" id="subtitle" value={selectedBlog.subtitle}
                        required
                        onChange={(e) => setSelectedBlog({ ...selectedBlog, subtitle: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                    </div>
                  </div>
                  <div className="w-full px-3 ">
                    <div className="mb-2">
                      <label htmlFor="subContent" className="mb-1 block text-base font-medium text-[#07074D]">
                        Текст 1
                      </label>
                      <textarea type="textarea" name="subContent" id="subContent" value={selectedBlog.subContent}
                        required
                        onChange={(e) => setSelectedBlog({ ...selectedBlog, subContent: e.target.value })}
                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" ></textarea>
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="subImageUrl" className="mb-1 block text-base font-medium text-[#07074D]">
                        Слика
                      </label>
                      <input type="file" name="subImageUrl" id="subImageUrl" accept="image/*" disabled={selectedBlog.subImageUrl !== ""}
                        onChange={handleImageChange}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-1 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm text-xs" />
                      {errors.image && (
                        <p className="text-red-500 text-sm ">{errors.image}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mt-4">
                      <h2 className="text-xl font-bold">Преглед на слика:</h2>
                      <div className="flex gap-4 ">
                        {selectedBlog.subImageUrl && <div className="relative">
                          <img src={selectedBlog.subImageUrl} alt={`Слика од производот ${selectedBlog.subImageUrl}`} className="w-20 h-20 object-cover rounded-md" />
                          <button
                            name="subImageUrl"
                            onClick={(e) => removeImage(e, selectedBlog.subImageUrl)}
                            className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1"
                          >
                            X
                          </button>
                        </div>}
                      </div>
                    </div>
                  </div>
                </div>
                <h3 className='text-3xl mt-4 mb-4'>Трета секција</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="subtitle1" className="mb-1 block text-base font-medium text-[#07074D]">
                        Поднаслов 2
                      </label>
                      <input type="text" name="subtitle1" id="subtitle1" value={selectedBlog.subtitle1}
                        required
                        onChange={(e) => setSelectedBlog({ ...selectedBlog, subtitle1: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                    </div>
                  </div>
                  <div className="w-full px-3 ">
                    <div className="mb-2">
                      <label htmlFor="subContent1" className="mb-1 block text-base font-medium text-[#07074D]">
                        Текст 2
                      </label>
                      <textarea type="textarea" name="subContent1" id="subContent1" value={selectedBlog.subContent1}
                        required
                        onChange={(e) => setSelectedBlog({ ...selectedBlog, subContent1: e.target.value })}
                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" ></textarea>
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="subImageUrl1" className="mb-1 block text-base font-medium text-[#07074D]">
                        Слика2
                      </label>
                      <input type="file" name="subImageUrl1" id="subImageUrl1" accept="image/*" disabled={selectedBlog.subImageUrl1 !== ""}
                        onChange={handleImageChange}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-1 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm text-xs" />
                      {errors.image && (
                        <p className="text-red-500 text-sm ">{errors.image}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mt-4">
                      <h2 className="text-xl font-bold">Преглед на слика:</h2>
                      <div className="flex gap-4 ">
                        {selectedBlog.subImageUrl1 && <div className="relative">
                          <img src={selectedBlog.subImageUrl1} alt={`Слика од производот ${selectedBlog.subImageUrl1}`} className="w-20 h-20 object-cover rounded-md" />
                          <button
                            name="subImageUrl1"
                            onClick={(e) => removeImage(e, selectedBlog.subImageUrl1)}
                            className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1"
                          >
                            X
                          </button>
                        </div>}
                      </div>
                    </div>
                  </div>
                </div>
                <h3 className='text-3xl mt-4 mb-4'>Четврта секција</h3>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="subtitle2" className="mb-1 block text-base font-medium text-[#07074D]">
                        Поднаслов 3
                      </label>
                      <input type="text" name="subtitle2" id="subtitle2" value={selectedBlog.subtitle2}
                        required
                        onChange={(e) => setSelectedBlog({ ...selectedBlog, subtitle2: e.target.value })}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" />
                    </div>
                  </div>
                  <div className="w-full px-3 ">
                    <div className="mb-2">
                      <label htmlFor="2" className="mb-1 block text-base font-medium text-[#07074D]">
                        Текст 3
                      </label>
                      <textarea type="textarea" name="subContent2" id="subContent2" value={selectedBlog.subContent2}
                        required
                        onChange={(e) => setSelectedBlog({ ...selectedBlog, subContent2: e.target.value })}
                        className="textarea textarea-bordered w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm" ></textarea>
                    </div>
                  </div>
                </div>
                <div className="-mx-3 flex flex-wrap">
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mb-2">
                      <label htmlFor="subImageUrl2" className="mb-1 block text-base font-medium text-[#07074D]">
                        Слика 3
                      </label>
                      <input type="file" name="subImageUrl2" id="subImageUrl2" accept="image/*" disabled={selectedBlog.subImageUrl2 !== ""}
                        onChange={handleImageChange}
                        className="w-full rounded-md border border-[#e0e0e0] bg-white py-1 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md input-sm text-xs" />
                      {errors.image && (
                        <p className="text-red-500 text-sm ">{errors.image}</p>
                      )}
                    </div>
                  </div>
                  <div className="w-full px-3 sm:w-1/2">
                    <div className="mt-4">
                      <h2 className="text-xl font-bold">Преглед на слика:</h2>
                      <div className="flex gap-4 ">
                        {selectedBlog.subImageUrl2 && <div className="relative">
                          <img src={selectedBlog.subImageUrl2} alt={`Слика од производот ${selectedBlog.subImageUrl2}`} className="w-20 h-20 object-cover rounded-md" />
                          <button
                            name="subImageUrl2"
                            onClick={(e) => removeImage(e, selectedBlog.subImageUrl2)}
                            className="absolute top-0 right-0 text-red-500 bg-white rounded-full p-1"
                          >
                            X
                          </button>
                        </div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-action">
              {loading && (<span className="loading loading-spinner loading-xs"></span>)}
              <button className="btn btn-success" onClick={handleBlog} disabled={loading}>Зачувај</button>
              <button className="btn btn-warning" onClick={() => closeEditModal(true)} disabled={loading}>Откажи</button>
            </div>
            {errorMessage && (<p className='text-red-600 text-right mt-4'>{errorMessage}</p>)}
          </div>
        </div>
      )}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="modal modal-open">
            <div className="modal-box">
              <h3 className="text-xl font-semibold">Дали сте сигурни дека сакате да го избришите <span className='font-bold text-2xl'>{blogToDelete.title}</span>?</h3>
              <div className="modal-action">
                <button
                  onClick={confirmDelete}
                  className="btn btn-error"
                  disabled={loading}
                >
                  Избриши
                </button>
                <button
                  onClick={closeDeleteModal}
                  className="btn btn-primary"
                  disabled={loading}
                >
                  Откажи
                </button>
                {loading && (<span className="loading loading-spinner loading-xs"></span>)}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default BlogsManagement
